import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import {
  BooleanInput,
  maxLength,
  minLength,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
} from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { administrationRequests } from "api/administrationApi";
import { specialistRequests } from "api/specialistApi";

const NAMES_MAX_LENGTH = 200;
const DESCRIPTION_MAX_LENGTH = 2000;

const SaveForm = () => {
  const { setValue } = useFormContext();
  const hasDesiredDate = !!useWatch({ name: "hasDesiredDate" });
  const datesValidate = hasDesiredDate ? undefined : required();

  useEffect(() => {
    if (!hasDesiredDate) return;
    setValue("fromDate", null);
    setValue("toDate", null);
  }, [hasDesiredDate, setValue]);

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameBg"
          label="Име на български"
          validate={[required(), maxLength(NAMES_MAX_LENGTH), minLength(1)]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameEn"
          label="Име на английски"
          validate={[required(), maxLength(NAMES_MAX_LENGTH), minLength(1)]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="descriptionBg"
          label="Описание на български"
          validate={[required(), maxLength(DESCRIPTION_MAX_LENGTH), minLength(1)]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="descriptionEn"
          label="Описание на английски"
          validate={[required(), maxLength(DESCRIPTION_MAX_LENGTH), minLength(1)]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <ReferenceInput
          reference={specialistRequests.getHealthcareSpecialitySelect()}
          source="healthcareSpeciality"
        >
          <SelectInput
            optionText="nameBg"
            label="Специалност здравни грижи"
            emptyText={false}
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <ReferenceInput
          source="buildingId"
          reference={administrationRequests.getBuildingsSelect()}
        >
          <SelectInput
            label="Сграда"
            source="name"
            emptyText={false}
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <NumberInput
          source="durationInDays"
          label="Дни продължителност"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <NumberInput
          source="credits"
          label="Кредити"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <NumberInput
          source="year"
          label="Година"
          validate={[required(), minValue(2025)]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <BooleanInput
          source="hasDesiredDate"
          label="Начална дата на курса - по желание"
          defaultValue={false}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <CustomDateInput
          source="fromDate"
          label="От дата"
          noTime
          required={!hasDesiredDate}
          validate={datesValidate}
          // readOnly, not disabled: RHF never re-enables validation on a field once it was disabled.
          readOnly={hasDesiredDate}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <CustomDateInput
          source="toDate"
          label="До дата"
          noTime
          required={!hasDesiredDate}
          validate={datesValidate}
          readOnly={hasDesiredDate}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <NumberInput
          source="minimumParticipants"
          label="Минимум участници"
          validate={required()}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
